import { useGlobalContext } from "../../../../../Context/Context";
import Button from "../../../../Custom/Button/Button";

const styles = {
  button: {
    padding: "5px 30px",
    fontWeight: "bold",
    width: "15vw",
    height: "40px",
  },
};

// DODAJ onPrint u listu props-a koje prima funkcija
function ButtonsPocetna({ cancelPreview, setCurrentState, data, onPrint }) {
  const { dictionary } = useGlobalContext();

  const handleAzuriraj = () => {
    setCurrentState("EDIT");
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginTop: "15px",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
        }}
      >
        {/* DODAT onClick={onPrint} OVDE */}
        <div onClick={onPrint}>
          <Button activation={true} style={styles.button}>
            {dictionary["stampaj"] || "ШТАМПАЈ"}
          </Button>
        </div>

        <div>
          <Button activation={true} style={styles.button}>
            {dictionary["posalji"] || "ПОШАЉИ"}
          </Button>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: "10px",
        }}
      >
        <div onClick={cancelPreview}>
          <Button activation={true} style={styles.button}>
            {dictionary["nazad"] || "НАЗАД"}
          </Button>
        </div>

        {data?.stavke && (
          <div onClick={handleAzuriraj}>
            <Button activation={true} style={styles.button}>
              {dictionary["azuriraj"] || "АЖУРИРАЈ"}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ButtonsPocetna;
